import { useEffect, useId } from 'react'
import Highcharts from 'highcharts/highmaps'
import HC_map from 'highcharts/modules/map'
import HC_data from 'highcharts/modules/data'
import Papa from 'papaparse'
import ChartSkeleton from '../skeleton/ChartSkeleton'
import BaseChart from './BaseChart'

interface IMapProps {
  chartData: string
  mapData: object
  tooltipTitle?: string
  height?: string
}

interface MapPoint {
  code: string
  value: number
  color?: string
}
interface CsvRow {
  Code: string
  Value: string
  Color?: string
  [key: string]: string | undefined
}

const Map = (props: IMapProps) => {
  const { chartData, mapData, tooltipTitle, height = '400px' } = props
  const chartId = useId()

  useEffect(() => {
    if (typeof HC_map === 'function') {
      HC_map(Highcharts)
    }
    if (typeof HC_data === 'function') {
      HC_data(Highcharts)
    }
  }, [])

  const parsedData: MapPoint[] = Papa.parse<CsvRow>(chartData, {
    header: true,
    skipEmptyLines: true,
  }).data.map((row) => {
    const code = row.Code?.trim()
    const value = Number(row.Value?.trim())
    const color = row.Color?.trim()
    const dataPoint: MapPoint = {
      code,
      value,
    }

    if (color) {
      dataPoint.color = color
    }

    return dataPoint
  })

  const options = {
    chart: {
      map: mapData,
      height: height,
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: 'bottom',
      },
    },
    colorAxis: {
      min: 1,
      type: 'logarithmic',
      minColor: '#fff4e6',
      maxColor: '#d9480f',
      stops: [
        [0, '#fff4e6'],
        [0.67, '#ff922b'],
        [1, '#d9480f'],
      ],
    },
    tooltip: {
      valueDecimals: 0,
      valueSuffix: '',
    },
    series: [
      {
        name: tooltipTitle ? tooltipTitle : 'Count',
        joinBy: ['iso-a3', 'code'],
        data: parsedData,
        dataLabels: {
          enabled: false,
          format: '{point.name}',
          style: {
            fontWeight: 'normal',
          },
        },
        tooltip: {
          pointFormat: '{point.name}: {point.value}',
        },
      },
    ],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  }

  return (
    <>
      {mapData && chartData && <BaseChart options={options} id={chartId} isMap={true} />}
      {(!mapData || !chartData) && <ChartSkeleton fullWidth />}
    </>
  )
}

export default Map
